import { FC, useEffect, useState } from 'react';
import { Routes, Route, BrowserRouter, Navigate, useLocation } from 'react-router-dom';
import { PrivateRoutes } from './PrivateRoutes';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { Logout, AuthPage } from '../modules/auth';
import { App } from '../App';
import { useSelector } from 'react-redux';

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */

/**
 * Handles redirects for unauthenticated users.
 * Preserves query params for email verification and password reset links
 * even when the backend sends the user to the root URL.
 */
const AuthRedirect: FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get('type');

  if (type === 'accountVerified') {
    return <Navigate to={`/auth/account-verify${location.search}`} replace />;
  }
  if (type === 'forgotpassword') {
    return <Navigate to={`/auth/change-password${location.search}`} replace />;
  }

  return <Navigate to="/auth" replace />;
};

const AppRoutes: FC = () => {
  const state = useSelector((state: any) => state.auth);
  const [loading, setLoading] = useState(true);
  const isAuthenticated = state.isAuthenticated || localStorage.getItem('token');
  

  useEffect(() => {
    // Simulate loading until state is resolved
    const timer = setTimeout(() => {
      setLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    // Show a loading spinner or placeholder until the authentication state is resolved
    return <div>Caricamento in corso...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path="error/*" element={<ErrorsPage />} />
          <Route path="logout" element={<Logout />} />
          {isAuthenticated ? (
            <>
              <Route path="/*" element={<PrivateRoutes />} />
              <Route index element={<Navigate to="/devices" />} />
            </>
          ) : (
            <>
              <Route path="auth/*" element={<AuthPage />} />
              <Route path="*" element={<AuthRedirect />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
